import UniversalEmptyState from './UniversalEmptyState';

export default UniversalEmptyState;
